import React from 'react';
import classnames from 'classnames';

import './ActionPriority.less';

const ActionPriority = ({priority, status}) => {
  return (
    <div className="form-group action-priority">
        <label>Prioriteit:</label>
        <span className={classnames('form-control', {[priority]: status !== 3})}>{priority}</span>
    </div>
  );
};

export default ActionPriority;



// WEBPACK FOOTER //
// ./src/actions/ActionPriority.js